import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <>
    <circle fill="#393939" cx="12" cy="12" r="2.3" />
    <circle fill="#393939" cx="5.6" cy="12" r="2.3" />
    <circle fill="#393939" cx="18.5" cy="12" r="2.3" />
  </>,
  `More3PointsIcon`
);
